import React, { Component } from "react";
import CommonSplitView from "presentational/common/CommonSplitView";
import ItemDetailView from "presentational/common/ItemDetailView";
import ColonTextButtonView from "presentational/common/ColonTextButtonView";
import CategorySelectorModalView from "presentational/common/modals/CategorySelectorModalView";
import BrandSelectorModalView from "presentational/common/modals/BrandSelectorModalView";
import ColorSelectorModalView from "presentational/common/modals/ColorSelectorModalView";
import TagSelectorModalView from "presentational/common/modals/TagSelectorModalView";
import IconButtonView from "presentational/common/IconButtonView";
import { withStore } from "store/storeHandler";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import styles from "./ItemInfoAdderPanelView.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const commonCss = config.css.commonDevice;

const cssXL = {
  buttonArea: {
    marginBottom: desktopCss.standardPaddingBetweenContent
  }
};
const cssXS = {
  imageWrapper: {
    width: "40%",
    paddingBottom: mobileCss.standardPaddingBetweenContent
  },
  buttonArea: {
    height: `calc(env(safe-area-inset-bottom) + ${mobileCss.headerBarHeightPX}px)`
  },
  buttonWrapper: {
    paddingBottom: "calc(env(safe-area-inset-bottom))"
  }
};

class ItemInfoAdderPanelView extends Component {
  static propTypes = {
    imageDataURL: PropTypes.string.isRequired,
    itemInfo: PropTypes.shape({
      category: PropTypes.string.isRequired,
      brand: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      tag: PropTypes.string.isRequired
    }).isRequired,
    onInfoChange: PropTypes.func.isRequired,
    onBackClick: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired
  };

  state = {
    categoryModalOpen: false,
    brandModalOpen: false,
    colorModalOpen: false,
    tagModalOpen: false
  };

  getWidthOfLeftSide = fixedHeightValue => {
    const { maxWidthOfContentWithoutPadding, outerPaddingOfContent } =
      commonCss.itemDetail;
    return maxWidthOfContentWithoutPadding + outerPaddingOfContent * 2;
  };

  displayedText(type, value) {
    if (!value) return value;
    switch (type) {
      case "category":
        return (
          <TXT textType="category" categoryType="itemLabelName" name={value} />
        );
      case "color":
        return <TXT textType="color" name={value} />;
      default:
        return value;
    }
  }

  displayNotice(type) {
    const { NoticeModalActions } = this.props;
    let message;
    switch (type) {
      case "categoryNotFilledOut":
        message = <TXT name="msg_selectCategory" />;
        break;
      case "brandNotFilledOut":
        message = <TXT name="msg_enterBrand" />;
        break;
      default:
        console.log("error");
        console.error("error");
        break;
    }
    NoticeModalActions.openModal({ content: message });
  }

  getSecondaryText(type) {
    const { itemInfo } = this.props;
    return itemInfo[type] ? this.displayedText(type, itemInfo[type]) : null;
  }

  changeInfo(type, value) {
    const { onInfoChange } = this.props;
    onInfoChange(type, value);
  }

  handleOptBtnClick = type => () => {
    switch (type) {
      case "category":
        this.setState({ categoryModalOpen: true });
        break;
      case "brand":
        this.setState({ brandModalOpen: true });
        break;
      case "color":
        this.setState({ colorModalOpen: true });
        break;
      case "tag":
        this.setState({ tagModalOpen: true });
        break;
      default:
        console.log("error");
        console.error("error");
        break;
    }
  };

  handleClearBtnClick = type => () => {
    this.changeInfo(type, null);
  };

  handleValueSelect = type => value => {
    this.changeInfo(type, value);
  };

  handleNextClick = () => {
    const { onNextClick, itemInfo } = this.props;
    const { category, brand } = itemInfo;

    if (category === "") {
      this.displayNotice("categoryNotFilledOut");
    } else if (brand === "") {
      this.displayNotice("brandNotFilledOut");
    } else {
      onNextClick();
    }
  };

  handleModalClose = () => {
    this.setState({
      categoryModalOpen: false,
      brandModalOpen: false,
      colorModalOpen: false,
      tagModalOpen: false
    });
  };

  mobileLayout() {
    const { imageDataURL, itemInfo, onBackClick } = this.props;
    const { categoryModalOpen, brandModalOpen, colorModalOpen, tagModalOpen } =
      this.state;
    const css = cssXS;
    const deviceType = getDeviceType();

    return (
      <div className={cx("root", deviceType)}>
        <div className={cx("image-wrapper")} style={css.imageWrapper}>
          <img className={cx("image")} alt="" src={imageDataURL} />
        </div>
        <div className={cx("input-area")}>
          <ColonTextButtonView
            onClick={this.handleOptBtnClick("category")}
            primary={<TXT name="btnSelect_category" />}
            secondary={this.getSecondaryText("category")}
            disableRightMargin
            onClear={this.handleClearBtnClick("category")}
            showClearButton={!!itemInfo.category}
            showRequiredBadge
          />
          <ColonTextButtonView
            onClick={this.handleOptBtnClick("brand")}
            primary={<TXT name="btnSelect_brand" />}
            secondary={this.getSecondaryText("brand")}
            disableRightMargin
            onClear={this.handleClearBtnClick("brand")}
            showClearButton={!!itemInfo.brand}
            showRequiredBadge
          />
          <ColonTextButtonView
            onClick={this.handleOptBtnClick("color")}
            primary={<TXT name="btnSelect_color" />}
            secondary={this.getSecondaryText("color")}
            disableRightMargin
            onClear={this.handleClearBtnClick("color")}
            showClearButton={!!itemInfo.color}
          />
          <ColonTextButtonView
            onClick={this.handleOptBtnClick("tag")}
            primary={<TXT name="btnSelect_hash" />}
            secondary={this.getSecondaryText("tag")}
            disableRightMargin
            onClear={this.handleClearBtnClick("tag")}
            showClearButton={!!itemInfo.tag}
          />
        </div>
        <div className={cx("button-area")} style={css.buttonArea}>
          <div style={css.buttonWrapper}>
            <IconButtonView type={"back"} onClick={onBackClick} />
          </div>
          <div style={css.buttonWrapper}>
            <IconButtonView type={"next"} onClick={this.handleNextClick} />
          </div>
        </div>
        <CategorySelectorModalView
          value={itemInfo.category}
          leafCategoryMode
          open={categoryModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleValueSelect("category")}
        />
        <BrandSelectorModalView
          writeNewTagMode
          value={itemInfo.brand}
          open={brandModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleValueSelect("brand")}
        />
        <ColorSelectorModalView
          value={itemInfo.color}
          open={colorModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleValueSelect("color")}
        />
        <TagSelectorModalView
          multiTagMode
          value={itemInfo.tag}
          open={tagModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleValueSelect("tag")}
        />
      </div>
    );
  }

  desktopLayout() {
    const { imageDataURL, itemInfo, onBackClick } = this.props;
    const { categoryModalOpen, brandModalOpen, colorModalOpen, tagModalOpen } =
      this.state;
    const css = cssXL;
    const deviceType = getDeviceType();

    return (
      <div className={cx("root", deviceType)}>
        <CommonSplitView
          getWidthOfLeftSide={this.getWidthOfLeftSide}
          leftSideComponent={
            <div className={cx("image-wrapper")}>
              <ItemDetailView mode={"demo"} imageSrc={imageDataURL} cardView />
            </div>
          }
          rightSideComponent={
            <div>
              <div className={cx("button-area")} style={css.buttonArea}>
                <IconButtonView type={"back"} onClick={onBackClick} />
                <IconButtonView
                  type={"next"}
                  disableRightMargin
                  onClick={this.handleNextClick}
                />
              </div>
              <div className={cx("input-area")}>
                <ColonTextButtonView
                  onClick={this.handleOptBtnClick("category")}
                  primary={<TXT name="btnSelect_category" />}
                  secondary={this.getSecondaryText("category")}
                  disableRightMargin
                  onClear={this.handleClearBtnClick("category")}
                  showClearButton={!!itemInfo.category}
                  showRequiredBadge
                />
                <ColonTextButtonView
                  onClick={this.handleOptBtnClick("brand")}
                  primary={<TXT name="btnSelect_brand" />}
                  secondary={this.getSecondaryText("brand")}
                  disableRightMargin
                  onClear={this.handleClearBtnClick("brand")}
                  showClearButton={!!itemInfo.brand}
                  showRequiredBadge
                />
                <ColonTextButtonView
                  onClick={this.handleOptBtnClick("color")}
                  primary={<TXT name="btnSelect_color" />}
                  secondary={this.getSecondaryText("color")}
                  disableRightMargin
                  onClear={this.handleClearBtnClick("color")}
                  showClearButton={!!itemInfo.color}
                />
                <ColonTextButtonView
                  onClick={this.handleOptBtnClick("tag")}
                  primary={<TXT name="btnSelect_hash" />}
                  secondary={this.getSecondaryText("tag")}
                  disableRightMargin
                  onClear={this.handleClearBtnClick("tag")}
                  showClearButton={!!itemInfo.tag}
                />
              </div>
            </div>
          }
        />
        <CategorySelectorModalView
          value={itemInfo.category}
          leafCategoryMode
          open={categoryModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleValueSelect("category")}
        />
        <BrandSelectorModalView
          writeNewTagMode
          value={itemInfo.brand}
          open={brandModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleValueSelect("brand")}
        />
        <ColorSelectorModalView
          value={itemInfo.color}
          open={colorModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleValueSelect("color")}
        />
        <TagSelectorModalView
          multiTagMode
          value={itemInfo.tag}
          open={tagModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleValueSelect("tag")}
        />
      </div>
    );
  }

  render() {
    return getDeviceType() === "mobile"
      ? this.mobileLayout()
      : this.desktopLayout();
  }
}

export default withStore({
  dispatchMap: ["noticeModal"]
})(ItemInfoAdderPanelView);
